<template>
  <div class="bg-white rounded-2xl shadow-xl p-8 max-w-md mx-auto">
    <h3 class="text-xl font-bold mb-4" :class="titleClass">แจ้งเตือนเมื่อเปิดตัว</h3>
    <form @submit.prevent="handleNotifySubmit" class="space-y-4">
      <div>
        <input 
          v-model="notifyForm.email"
          type="email" 
          placeholder="กรอกอีเมลของคุณ"
          :class="inputClass"
          required
        >
      </div>
      <div>
        <input 
          v-model="notifyForm.name"
          type="text" 
          placeholder="ชื่อของคุณ (ไม่บังคับ)"
          :class="inputClass"
        >
      </div>
      <button 
        type="submit"
        :disabled="submitting"
        :class="buttonClass"
      >
        {{ submitting ? 'กำลังส่ง...' : 'แจ้งเตือนฉัน' }}
      </button>
    </form>
    
    <!-- Success Message -->
    <div v-if="notifySuccess" :class="successClass">
      ✓ ขอบคุณ! เราจะแจ้งเตือนคุณเมื่อเว็บไซต์เปิดตัว
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  site: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: 'green'
  }
})

const submitting = ref(false)
const notifySuccess = ref(false)

// Notify form data
const notifyForm = ref({
  email: '',
  name: ''
})

// Color classes based on color prop
const titleClass = computed(() => {
  const colorMap = {
    green: 'text-gray-900',
    amber: 'text-amber-900',
    blue: 'text-blue-900',
    orange: 'text-orange-900',
    emerald: 'text-emerald-900',
    purple: 'text-purple-900'
  }
  return colorMap[props.color] || 'text-gray-900'
})

const inputClass = computed(() => {
  const colorMap = {
    green: 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500',
    amber: 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500',
    blue: 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
    orange: 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500',
    emerald: 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500',
    purple: 'w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500'
  }
  return colorMap[props.color] || colorMap.green
})

const buttonClass = computed(() => {
  const colorMap = {
    green: 'w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200',
    amber: 'w-full bg-amber-600 hover:bg-amber-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200',
    blue: 'w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200',
    orange: 'w-full bg-orange-600 hover:bg-orange-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200',
    emerald: 'w-full bg-emerald-600 hover:bg-emerald-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200',
    purple: 'w-full bg-purple-600 hover:bg-purple-700 disabled:bg-gray-400 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200'
  }
  return colorMap[props.color] || colorMap.green
})

const successClass = computed(() => {
  const colorMap = {
    green: 'mt-4 p-4 bg-green-100 text-green-700 rounded-lg',
    amber: 'mt-4 p-4 bg-amber-100 text-amber-700 rounded-lg',
    blue: 'mt-4 p-4 bg-blue-100 text-blue-700 rounded-lg',
    orange: 'mt-4 p-4 bg-orange-100 text-orange-700 rounded-lg',
    emerald: 'mt-4 p-4 bg-emerald-100 text-emerald-700 rounded-lg',
    purple: 'mt-4 p-4 bg-purple-100 text-purple-700 rounded-lg'
  }
  return colorMap[props.color] || colorMap.green
})

// Handle notify form submission
const handleNotifySubmit = async () => {
  submitting.value = true
  
  try {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000))
    
    // Here you would normally send the data to your backend
    console.log('Notify submission:', {
      site: props.site,
      email: notifyForm.value.email,
      name: notifyForm.value.name
    })
    
    notifySuccess.value = true
    notifyForm.value.email = ''
    notifyForm.value.name = ''
    
    // Hide success message after 5 seconds
    setTimeout(() => {
      notifySuccess.value = false
    }, 5000)
    
  } catch (error) {
    console.error('Notify submission error:', error)
  } finally {
    submitting.value = false
  }
}
</script>